<div class="highlighter-wrapper" *ngIf="visible">
    <i class="pi pi-times align-self-end cursor-pointer color-greyish opacity-8" (click)="visible = false"></i>
    <span>Se han encontrado <strong>{{formErrors?.length}}</strong> campos con <strong>errores de validación</strong></span>
    <div class="d-flex justify-content-end aling-items-center mt-3">
        <!-- <span class="fw-bold text-underline cursor-pointer" (click)="onBackClick()">ANTERIOR</span> -->
        <span class="fw-bold text-underline cursor-pointer" (click)="onNextClick()">VER ERROR</span>
    </div>
</div>